import { driver } from 'driver.js';

import 'driver.js/dist/driver.css';
import './MobileParentMapIntro.css';
import elevateLogo from '@/assets/logo.svg';
import { isLocalStorageAvailable } from '@/utils';

interface MobileParentMapIntroProps {
	isEnabled: boolean;
	setIsEnabled: (value: boolean) => void;
}

const MobileParentMapIntro = ({ isEnabled, setIsEnabled }: MobileParentMapIntroProps) => {
	const handleExit = () => {
		if (isLocalStorageAvailable()) {
			localStorage.setItem('elevateMobileCourseMapTutorial', 'false');
		}
		setIsEnabled(false);
	};

	const driverObj = driver({
		showProgress: true,
		nextBtnText: 'Next',
		prevBtnText: 'Previous',
		onDestroyed: () => {
			handleExit();
		},
		steps: [
			{
				popover: {
					popoverClass: 'has-default-height',
					description: `<img src=${elevateLogo}><br />Welcome to the Course Map. Press next to learn how to navigate course pathways on your device.`,
					align: 'center',
				},
			},
			{
				popover: {
					popoverClass: 'has-default-height',
					title: 'Privacy Consent',
					description:
						'By using this application, you consent to the following: The information on this site may not be reproduced, transmitted, or copied without the express written permission of Stakk IO.',
					align: 'center',
				},
			},
			{
				element: '.mobile-search-bar',
				popover: {
					title: 'Search Courses',
					description:
						'Use the search bar to quickly find any course across all disciplines by name.',
					align: 'center',
				},
			},
			{
				element: '.mobile-discipline-list',
				popover: {
					title: 'Course Disciplines',
					description:
						'Each card represents a subject discipline. Tap any card to explore the courses and pathways within that discipline.',
					align: 'center',
					onNextClick: () => {
						const firstCard = document.querySelector<HTMLElement>('.mobile-discipline-card');
						if (firstCard) {
							firstCard.click();
						}
						setTimeout(() => driverObj.moveNext(), 200);
					},
				},
			},
			{
				element: '.mobile-course-row',
				popover: {
					title: 'Course Pathways',
					description:
						"Each row is a course in this discipline's sequence. Rows with a chevron lead deeper — tap them to follow the pathway forward.",
					align: 'center',
					onPrevClick: () => {
						const homeBtn = document.querySelector<HTMLElement>('.mobile-home-btn');
						if (homeBtn) {
							homeBtn.click();
						}
						setTimeout(() => driverObj.movePrevious(), 200);
					},
					onNextClick: () => {
						const firstExpandable = document.querySelector<HTMLElement>(
							'.mobile-course-row[role="button"]'
						);
						if (firstExpandable) {
							firstExpandable.click();
						}
						setTimeout(() => driverObj.moveNext(), 200);
					},
				},
			},
			{
				element: '.mobile-breadcrumbs',
				popover: {
					title: 'Your Path Trail',
					description:
						"The trail at the top tracks every level you've entered. Tap any chip to jump back to that point, or tap the home icon to return to all disciplines.",
					align: 'center',
				},
			},
			{
				element: '.mobile-subway-strip',
				popover: {
					title: 'Your Path Map',
					description:
						"This strip shows every course in your current path. Tap any node to open that course's full details without losing your place.",
					align: 'center',
				},
			},
			{
				popover: {
					popoverClass: 'has-default-height',
					title: 'View Course Details',
					description:
						'Tap the View button on any course to open a detailed panel with its description, learning outcomes, resources, and units of focus. Click done and give it a try!',
					align: 'center',
				},
			},
		],
	});

	if (isEnabled) {
		driverObj.drive();
	}

	return null;
};

export default MobileParentMapIntro;
